import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import axios from 'axios';
import anime from 'animejs/lib/anime.es.js'
import { Constant } from '@/utils/const';

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.prototype.$axios = axios;
Vue.prototype.$Constant = Constant;
Vue.prototype.$anime = anime;


// var VueScrollTo = require('vue-scrollto');

// Vue.use(VueScrollTo)

// You can also pass in the default options
// Vue.use(VueScrollTo, {
//   container: "body",
//   duration: 500,
//   easing: "ease",
//   offset: 0,
//   force: true,
//   cancelable: true,
//   onStart: false,
//   onDone: false,
//   onCancel: false,
//   x: false,
//   y: true
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

